module.exports = "<template>\r\n    <div class=\"alert alert-danger\">${errorMessage}</div>\r\n</template>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/error/error.html
// module id = app/components/error/error.html
// module chunks = 0